export const ACCEPTED_COOKIES = 'acceptedCookies'
